import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function OwnerBillingPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Facturación (Owner)</h1>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Planes y licencias</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Asignación manual de planes por empresa. Próximamente.</p>
        </CardContent>
      </Card>
    </div>
  );
}
